import OrgUnit from '@legacy-modules/metrics2/models/entities/organization/OrgUnit';
import Model, { DefaultType, MemberType } from '@legacy-modules/utils/Model';
import { NodeData } from '@legacy-modules/navigation/TreeMenu';
import { formatOrgUnitLabel } from '@legacy-modules/navigation/components/OrganizationMultiSelection';

export default class OrgUnitNode extends Model<OrgUnitNode> {
  public orgUnit: OrgUnit;
  children: Array<OrgUnitNode>;
  parent?: OrgUnitNode;

  constructor(source: unknown = null, shallow: boolean = false) {
    super();
    this.hydrateFrom(source, shallow, this.getDefaults(), this.getMembers());
  }

  get data(): NodeData {
    return {
      toString: () => formatOrgUnitLabel(this.orgUnit),
      getIdentifier: () => this.orgUnit.orgKey,
    };
  }

  getDefaults(): DefaultType<OrgUnitNode> {
    return undefined;
  }

  getMembers(): MemberType<OrgUnitNode> {
    return undefined;
  }
}
